import React from 'react';
import styled from 'styled-components';
import { Title } from '../../UI/Typography';
import LeaveTable from '../Components/LeaveTable';

const PageContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
`;

function LeavesMain() {
  return (
    <PageContainer>
      <Title>Leave Requests</Title>
      <LeaveTable />
    </PageContainer>
  );
}

export default LeavesMain;
